<template>
  <div>
    <DrawablePhotoV1OrV2
      v-if="isShowPhoto"
      :image="imageObj"
      :drawing="drawing"
      :title="$t('Annotate image')"
      :remove-button-title="$t('Remove annotation')"
      :can-be-deleted="false"
      @change="updateDrawing"
    />
    <p v-else>{{ $t('No image set to annotate.') }}</p>
  </div>
</template>

<script>
  import { DrawablePhotoV1OrV2 } from '@/_legacy/components/DrawablePhoto/DrawablePhotoV1OrV2';
  import * as AssetsPhotoStateService from '@/services/assets-api/AssetsPhotoStateService';

  export default {
    components: { DrawablePhotoV1OrV2 },
    props: {
      item: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        loading: false,
      };
    },
    computed: {
      drawing() {
        return this.item.response && this.item.response.drawing ? this.item.response.drawing : null;
      },
      imageObj() {
        return { ...this.item.params, ...(this.item.response || {}) };
      },
      isShowPhoto() {
        return (this.item.params.image || this.item.params.image_id) && !this.loading;
      }
    },
    methods: {
      removeDrawing() {
        const photoToDelete = this.item.response || {};
        if (!photoToDelete) {
          return;
        }

        AssetsPhotoStateService.deleteDrawing(photoToDelete);

        this.$delete(this.item, 'response');
        this.$set(this.item, 'responded', false);
      },
      updateDrawing(drawing) {
        this.loading = true;

        if (!drawing) {
          this.removeDrawing();

          this.loading = false;
          return;
        }

        const photoToUpdate = this.item.response || {};

        AssetsPhotoStateService.updateDrawing(photoToUpdate, drawing);

        this.$set(this.item, 'response', { ...photoToUpdate });
        this.$set(this.item, 'responded', true);
        this.loading = false;
      },
    },
  };
</script>
